import React from 'react'
import {Icon} from "atmosfair-ui";
import {AllActivityTypes} from "../../../../types-enums/activity";
import {Tooltip} from "@mui/material";
import {generateActivityEmissionsCalculationTierString} from "../../../../utils/string/common";
import {useTranslation} from "react-i18next";
import {ICON_MARGIN} from "../utils";
import {allActivitiesCalculatedWithError} from "../../../../utils/check/emissions";

export interface StringDisplayCalculationTierHintProps {
    activity: AllActivityTypes,
    iconColor?: string,
}

const CalculationTierTooltipHint = ({
                                        activity,
                                        iconColor
                                    }: StringDisplayCalculationTierHintProps) => {
    const {i18n} = useTranslation()
    const tooltip = generateActivityEmissionsCalculationTierString(activity, i18n)
    const calculationFailed = allActivitiesCalculatedWithError(activity.common.totalEmissions)
    if (tooltip !== null && !calculationFailed) return <Tooltip
        placement={"top"}
        title={tooltip}>
        <div style={ICON_MARGIN}>
            <Icon
                color={iconColor}
                size={"verySmall"}
                icon={"comment"}/>
        </div>
    </Tooltip>
    return null
}

export default CalculationTierTooltipHint